import type { PlatformOptions } from "../../shared/apollo/OneGraphApolloClientProvider";

import { resolveOneGraphConfig } from "../../shared/apollo/oneGraphConfig";

declare global {
  var graphqlUrl: string | undefined;
  var graphqlIndeedApiKey: string | undefined;
}

/**
 * Resolution order for OneGraph URL and API key:
 *   1. `globalThis.graphqlUrl` / `globalThis.graphqlIndeedApiKey` — explicit
 *      host-injected globals (JSF-628)
 *   2. `resolveOneGraphConfig(_tareData.stagingLevel)` — the dedicated
 *      `viewjob-web` client.
 *
 */
export function getPlatformOptions(): PlatformOptions {
  const { url, apiKey } = resolveOneGraphConfig(globalThis._tareData?.stagingLevel);

  return {
    web: {
      graphqlUrl: globalThis.graphqlUrl ?? url,
      graphqlApiKey: globalThis.graphqlIndeedApiKey ?? apiKey,
    },
  };
}
